import React from "react";
import Flx from "../../layout/Flx";
import Txt from "../../typography/Txt";
import colors from "../../../theme/colors";

/**
 * RffCheckboxGroup — a labelled "check all that apply" list. Stacks
 * RffBooleanCheckbox children vertically with comfortable spacing. Use `indent`
 * for a follow-up sub-checklist revealed by a gating checkbox; it draws a left
 * rule and pushes the items in so the hierarchy reads at a glance.
 */
const RffCheckboxGroup = ({ label, indent = false, gap = 1.25, sx, children }) => (
  <Flx
    column
    gap={1.5}
    sx={{
      ...(indent && {
        ml: 1,
        pl: 2.5,
        borderLeft: `2px solid ${colors.slate200}`,
      }),
      ...sx,
    }}
  >
    {label && (
      <Txt
        component="div"
        variant="body2"
        sx={{ fontWeight: 600, color: colors.slate600 }}
      >
        {label}
      </Txt>
    )}
    <Flx column gap={gap}>
      {children}
    </Flx>
  </Flx>
);

export default RffCheckboxGroup;
